import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminHome from "./pages/HomeAdmin";
import HomeDriver from "./pages/HomeDriver";
import DriverDeliveries from "./pages/DriverDeliveries";
import DriverProfile from "./pages/DriverProfile";
import SellerHome from "./pages/SellerHome";
import SellerDeliveries from "./pages/SellerDeliveries";
import Totales from "./pages/Totales";
import Stores from "./pages/Stores";
import PriceLists from "./pages/PriceLists";
import Users from "./pages/Users";
import ManualLoad from "./pages/ManualLoad";
import Deliveries from "./pages/Deliveries";
import DeliveriesLoad from "./pages/DeliveriesLoad";

import AdminLayout from "./Layouts/AdminLayout";
import DriverLayout from "./Layouts/DriverLayout";
import SellerLayout from "./Layouts/SellerLayout";
import ProtectedRoute from "./components/auth/ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminHome />} />

            <Route path="envios" element={<Deliveries />} />
            <Route path="envios/carga" element={<DeliveriesLoad />} />

            <Route
              path="envios/etiquetas"
              element={
                <div style={{ padding: "24px", color: "var(--text-primary)" }}>
                  Impresión de etiquetas
                </div>
              }
            />

            <Route
              path="envios/rutear"
              element={
                <div style={{ padding: "24px", color: "var(--text-primary)" }}>
                  Rutear envíos
                </div>
              }
            />

            <Route path="liquidaciones/carga-manual" element={<ManualLoad />} />
            <Route path="liquidaciones/totales" element={<Totales />} />

            <Route path="stores" element={<Stores />} />
            <Route path="users" element={<Users />} />

            <Route path="sistema/listas-de-precios" element={<PriceLists />} />

            <Route path="dashboard" element={<Dashboard />} />
            <Route path="totales" element={<Totales />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["DRIVER"]} />}>
          <Route path="/driver" element={<DriverLayout />}>
            <Route index element={<HomeDriver />} />
            <Route path="deliveries" element={<DriverDeliveries />} />

            <Route
              path="pickups"
              element={
                <div style={{ padding: "24px", color: "var(--text-primary)" }}>
                  Mis colectas
                </div>
              }
            />

            <Route path="profile" element={<DriverProfile />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["SELLER"]} />}>
          <Route path="/seller" element={<SellerLayout />}>
            <Route index element={<SellerHome />} />
            <Route path="envios" element={<SellerDeliveries />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;